import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom'

import './assets/css/style.css';

import App from './components/App';

// structure for routes is from the following:
// https://medium.com/@pshrmn/a-simple-react-router-v4-tutorial-7f23ff27adf
ReactDOM.render((
	<BrowserRouter>
		<App />
	</BrowserRouter>
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js